<template>
  <v-container fluid class="pa-0">
    <v-row>
      <v-col cols="12" sm="12" md="4" class="pt-0 mt-md-n10">
        <MediaModeForm v-if="(currentUser.clientType === 'Media' || currentUser.clientType === 'Driblab') && selectedTab === 'topView'" :fields="mediaModeFields"
        :mediaMode="mediaMode" @mediaModeChange="onMediaModeChange($event)"
        :mediaModeData="mediaModeData" @mediaModeDataChange="onMediaModeDataChange($event)" selectorMode></MediaModeForm>
        <v-card class="pb-2" elevtion="0" outlined>
          <v-row class="mx-0 pt-0">
            <v-col class="d-flex pb-3 pl-0 justify-center" cols="12" v-if="$vuetify.breakpoint.smAndDown">
              <v-btn color="primary" small outlined rounded @click="showShotOptions = !showShotOptions" class="elevation-0 monospace-font">
                {{ showShotOptions ? $t('game.detail.hideShotOptions') : $t('game.detail.showShotOptions')}}  <v-icon right > {{ showShotOptions ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" class="py-3">
              <v-card-title class="pa-0 header-font pt-2" style="font-size: 22px;">{{ $t('general.filters') }}</v-card-title>
            </v-col>
            <v-col class="py-0" cols="12" sm="12" v-if="showShotOptions">
              <p class="my-0 pa-0 primary--text font-weight-bold body-1">{{ $t('general.displayType') }}</p>
              <v-radio-group v-model="selectedTab" mandatory row hide-details @change="onTabChange($event)" class="pt-2 ma-0">
                <v-radio value="topView" color="secondary">
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ $t("playerDetail.placer") }} <v-icon small class="ms-1">border_horizontal</v-icon></span>
                  </template>
                </v-radio>
                <v-radio value="chartView" color="secondary">
                  <template v-slot:label>
                    <span class="body-1 primary--text">xG<v-icon small class="ms-1">show_chart</v-icon></span>
                  </template>
                </v-radio>
                <v-radio value="tableView" color="secondary" class="mr-0">
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{$t('charts.table')}}<v-icon small class="ms-1">table_rows</v-icon></span>
                  </template>
                </v-radio>
              </v-radio-group>
              <p class="my-0 pa-0 primary--text font-weight-bold body-1 mt-2">{{ $t('finishingMap.typesOfShot') }}</p>
              <v-autocomplete
                :items="shotTypes"
                v-model="shotTypeModel"
                item-text="text"
                item-value="id"
                class="body-1 mb-4"
                multiple dense hide-details clearable
                @input="updateShots();"
              >
                <v-list-item
                  slot="prepend-item"
                  ripple
                  @click="toggleShotTypes"
                >
                <v-list-item-content>
                  <v-list-item-title>{{ $t('finishingMap.selectAll') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
                <v-divider
                  slot="prepend-item"
                  class="mt-2"
                ></v-divider>
                <template
                  slot="selection"
                  slot-scope="{ item, index }"
                >
                  <v-chip v-if="index === 0" small color="lightSecondary lighten-2">
                    <span class="black--text">&nbsp;{{ item.text }}</span>
                  </v-chip>
                  <span
                    v-if="index === 1"
                    class="primary--text body-2 subheader-font"
                  >(+{{ shotTypeModel.length - 1 }} {{ $t('finishingMap.more') }})</span>
                </template>
                <template v-slot:item="{item}">
                  <span class="body-2 primary--text">{{item.text}}</span>
                </template>
              </v-autocomplete>
              <p class="my-0 pa-0 primary--text font-weight-bold body-1 mt-2">{{ $t('finishingMap.shotStrategy') }}</p>
              <v-autocomplete
                :items="shotStrategies"
                v-model="shotStrategyModel"
                item-text="text"
                item-value="id"
                class="body-1 mb-4"
                multiple dense hide-details clearable
                @input="updateShots();"
              >
              <v-list-item
                slot="prepend-item"
                ripple
                @click="toggleShotStrategies"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ $t('finishingMap.selectAll') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                slot="prepend-item"
              ></v-divider>
                <template
                  slot="selection"
                  slot-scope="{ item, index }"
                >
                  <v-chip v-if="index === 0" small color="lightSecondary lighten-2">
                    <span class="black--text">&nbsp;{{ item.text }}</span>
                  </v-chip>
                  <span
                    v-if="index === 1"
                    class="primary--text body-2 subheader-font"
                  >(+{{ shotStrategyModel.length - 1 }} {{ $t('finishingMap.more') }})</span>
                </template>
                <template v-slot:item="{item}">
                  <span class="body-2 primary--text">{{item.text}}</span>
                </template>
              </v-autocomplete>
              <p class="my-0 pa-0 primary--text font-weight-bold body-1 mt-2">{{ $t('finishingMap.areas') }}</p>
              <v-autocomplete
                :items="areas"
                v-model="areaModel"
                item-text="text"
                item-value="id"
                class="body-1 mb-4"
                multiple dense hide-details clearable
                @input="updateShots();"
              >
                <v-list-item
                  slot="prepend-item"
                  ripple
                  @click="toggleAreas"
                >
                <v-list-item-content>
                  <v-list-item-title>{{ $t('finishingMap.selectAll') }}</v-list-item-title>
                </v-list-item-content>
                </v-list-item>
                <v-divider
                  slot="prepend-item"
                  class="mt-2"
                ></v-divider>
                <template
                  slot="selection"
                  slot-scope="{ item, index }"
                >
                  <v-chip v-if="index === 0" small color="lightSecondary lighten-2">
                    <span class="black--text">&nbsp;{{ item.text }}</span>
                  </v-chip>
                  <span
                    v-if="index === 1"
                    class="primary--text body-2 subheader-font"
                  >(+{{ areaModel.length - 1 }} {{ $t('finishingMap.more') }})</span>
                </template>
                <template v-slot:item="{item}">
                  <span class="body-2 primary--text">{{item.text}}</span>
                </template>
              </v-autocomplete>
              <p class="my-0 pa-0 primary--text font-weight-bold body-1 mt-2">{{ $t('finishingMap.bodyPart') }}</p>
              <v-autocomplete
                :items="bodyParts"
                v-model="bodyPartModel"
                item-text="text"
                item-value="id"
                class="body-1 mb-2"
                multiple dense hide-details clearable
                @input="updateShots();"
              >
                <v-list-item
                  slot="prepend-item"
                  ripple
                  @click="toggleBodyPart"
                >
                <v-list-item-content>
                  <v-list-item-title>{{ $t('finishingMap.selectAll') }}</v-list-item-title>
                </v-list-item-content>
                </v-list-item>
                <v-divider
                  slot="prepend-item"
                  class="mt-2"
                ></v-divider>
                  <template
                    slot="selection"
                    slot-scope="{ item, index }"
                  >
                  <v-chip v-if="index === 0" small color="lightSecondary lighten-2">
                    <span class="black--text">&nbsp;{{ item.text }}</span>
                  </v-chip>
                  <span
                    v-if="index === 1"
                    class="primary--text body-2 subheader-font"
                  >(+{{ bodyPartModel.length - 1 }} {{ $t('finishingMap.more') }})</span>
                </template>
                <template v-slot:item="{item}">
                  <span class="body-2 primary--text">{{item.text}}</span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col class="py-1" cols="12" sm="12" v-if="showShotOptions">
              <p class="my-0 pa-0 primary--text font-weight-bold body-1 mt-2">{{ $t('game.gamePossessionMap.time') }}</p>
            </v-col>
            <v-col class="d-flex flex-wrap py-0" cols="12" v-if="showShotOptions">
              <v-checkbox
                v-model="periods"
                :label="$t('general.firstHalf')"
                color="secondary"
                value="period1"
                hide-details
                class="px-1 py-0 ma-0 me-3"
                @change="updateShots()"
              >
                <template v-slot:label>
                  <span class="body-1 primary--text">{{ $t('general.firstHalf') }}</span>
                </template>
              </v-checkbox>
              <v-checkbox
                v-model="periods"
                :label="$t('general.secondHalf')"
                color="secondary"
                value="period2"
                hide-details
                class="px-1 py-0 ma-0"
                @change="updateShots()"
              >
                <template v-slot:label>
                  <span class="body-1 primary--text">{{ $t('general.secondHalf') }}</span>
                </template>
              </v-checkbox>
            </v-col>
            <v-col class="d-flex flex-wrap pt-0 pb-1" cols="12" v-if="showShotOptions">
              <v-checkbox
                v-if="hasFirstOT"
                v-model="periods"
                :label="$t('general.firstPeriodOT')"
                color="secondary"
                value="period3"
                hide-details
                class="px-1 py-0 ma-0"
                @change="updateShots()"
              >
                <template v-slot:label>
                  <span class="body-1 primary--text">{{ $t('general.firstPeriodOT') }}</span>
                </template>
              </v-checkbox>
              <v-checkbox
                v-if="hasSecondOT"
                v-model="periods"
                :label="$t('general.secondPeriodOT')"
                color="secondary"
                value="period4"
                hide-details
                class="px-1 py-0 ma-0"
                @change="updateShots()"
              >
                <template v-slot:label>
                  <span class="body-1 primary--text">{{ $t('general.secondPeriodOT') }}</span>
                </template>
              </v-checkbox>
            </v-col>
            <v-col class="py-1" cols="12" sm="12" v-if="showShotOptions && hasPenalties">
              <p class="my-0 pa-0 primary--text font-weight-bold body-1 mt-2">{{ $t('game.detail.penalties') }}</p>
            </v-col>
            <v-col class="d-flex flex-wrap pt-0 pb-1" cols="12" v-if="showShotOptions && hasPenalties">
              <v-checkbox
                v-if="penalties.length"
                v-model="showPenalties"
                :label="$t('finishingMap.penalty')"
                color="secondary"
                hide-details
                class="px-1 py-0 ma-0"
                @change="updateShots()"
              >
                <template v-slot:label>
                  <span class="body-1 primary--text">{{ $t('finishingMap.penalty') }}</span>
                </template>
              </v-checkbox>
              <v-checkbox
                v-if="penaltiesShootout.length"
                v-model="showShootoutPenalties"
                :label="$t('finishingMap.penaltyShootout')"
                color="secondary"
                hide-details
                class="px-1 py-0 ma-0"
                @change="updateShots()"
              >
                <template v-slot:label>
                  <span class="body-1 primary--text">{{ $t('finishingMap.penaltyShootout') }}</span>
                </template>
              </v-checkbox>
            </v-col>
            <v-col class="d-flex pt-1 pb-2 mb-5" cols="12" sm="12" v-if="showShotOptions">
              <v-range-slider
                thumb-label
                v-model="minutes"
                :max="minutesMax"
                :min="minutesMin"
                step="1"
                hide-details
                :color="`secondary ${$vuetify.theme.dark ? 'lighten-3' : ''}`"
                class="align-center py-0"
                @input="updateShots"
              >
                <template v-slot:label>
                  <div class="d-flex flex-column">
                    <span class="primary--text font-weight-bold body-1">{{ $t('finishingMap.minutes') }}</span>
                    <span class="body-2 subheader-font monospace-font">{{ `(${minutesMin} - ${minutesMax})` }}</span>
                  </div>
                </template>
              </v-range-slider>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row class="px-3" v-if="selectedTab != 'tableView'">
            <v-col class="d-flex justify-end pt-2 pb-1 px-2" cols="12" >
              <v-btn
                color="secondary" class="elevation-0 monospace-font white--text px-3 mx-1" rounded small
                :x-small="!$vuetify.breakpoint.xsOnly"
                v-on:click.native="saveAsPNG()"
              >
                <v-icon small class="mr-1">
                  file_download</v-icon
                >
                <span class="">PNG</span>
              </v-btn>
              <v-btn
                color="secondary" class="elevation-0 monospace-font white--text px-3 mx-1" rounded small
                :x-small="!$vuetify.breakpoint.xsOnly"
                v-on:click.native="saveAsSVG()"
              >
                <v-icon small
                  >file_download</v-icon
                >
                <span>SVG</span>
              </v-btn>
              <v-btn
                color="secondary" class="elevation-0 monospace-font white--text px-3 mx-1" rounded small
                :x-small="!$vuetify.breakpoint.xsOnly"
                :loading="loadingExport"
                :disabled="!chartSize"
                v-on:click.native="onGenerateIFrameClick()"
              >
                <v-icon small class="mr-1"
                  >share</v-icon
                >
                <span>Embed</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" :md="8" id="chart" ref="chart" class="text-right pt-0">
        <GameAvatarMedia v-if="avatarSize && mediaMode && game" :width="size" :height="avatarSize.height" :id="`${gameId}-${chartId}`" :game="game"
          :margin="margin" :titleLeft="mediaModeData.titleLeft" :titleRight="mediaModeData.titleRight"
          :leftColor="isWhite(mediaModeData.leftFillColor) ? mediaModeData.leftBorderColor : mediaModeData.leftFillColor"
          :rightColor="isWhite(mediaModeData.rightFillColor) ? mediaModeData.rightBorderColor : mediaModeData.rightFillColor"
          ref="gameAvatarMediaRef" :bgColor="mediaModeData.bgColor" :textColor="mediaModeData.textColor"
          type="finishingMap" :lineDistance="mediaModeData.lineLength" :avatarSize="mediaModeData.avatarSize" :lineWeight="mediaModeData.lineWeight"
          :titleFontSize="mediaModeData.titleFontSize" :titleFontWeight="mediaModeData.titleFontWeight"
          :subtitle="mediaModeData.subtitle" :subtitleFontSize="mediaModeData.subtitleFontSize" :subtitleFontWeight="mediaModeData.subtitleFontWeight"
          :subtitle2="mediaModeData.subtitle2" :subtitle2FontSize="mediaModeData.subtitle2FontSize" :subtitle2FontWeight="mediaModeData.subtitle2FontWeight"
          ></GameAvatarMedia>
        <XGChart
          v-if="size != 0 && game != null && shots.length > 0 && selectedTab === 'topView'"
          :id="`${gameId}-${chartId}`"
          :size="size"
          :game="game"
          :shots="filteredShots"
          :key="xgMap"
          :circlesAndBoxes="checkboxCircles"
          :language="currentUserLanguage"
          :homeFillColor="mediaModeData.leftFillColor"
          :homeBorderColor="mediaModeData.leftBorderColor"
          :awayFillColor="mediaModeData.rightFillColor"
          :awayBorderColor="mediaModeData.rightBorderColor"
          :homeTeamName="mediaModeData.titleLeft"
          :awayTeamName="mediaModeData.titleRight"
          :mediaMode="mediaMode"
          @sizeChange="onChartSizeChange($event)"
          @loaded="onLoaded($event)"
          :showPenalties="showPenalties || showShootoutPenalties"
        />
        <RaceChart id="GameXG" :game="game" :shotData="filteredShots" :key="xgMap"
          :size="size"
           v-if="size != 0 && game != null && shots.length > 0 && selectedTab === 'chartView'"
           @sizeChange="onChartSizeChange($event)"
           @loaded="onLoaded($event)"/>
        <ShotsTable :shots="filteredShots" v-if="selectedTab === 'tableView'"/>
        <DriblabSocialMedia v-if="game && avatarSize && size && mediaMode && mediaModeData.socialMedia"  :width="size" :height="50" :id="`${gameId}-${chartId}`"
          :margin="margin" ref="driblabSocialMediaRef" :bgColor="mediaModeData.bgColor" :textColor="mediaModeData.textColor"
          :fontSize="mediaModeData.socialMediaFontSize" :fontWeight="mediaModeData.socialMediaFontWeight" :sponsor="mediaModeData.sponsor.dataUrl"
          :logoCfg="mediaModeData.logo" type="finishingMap"></DriblabSocialMedia>
      </v-col>
    </v-row>
    <ChartExportLinksModal ref="chartExportLinksModalRef" :title="`${game.homeTeamName} ${game.homeTeamScore} - ${game.awayTeamScore} ${game.awayTeamName}`" v-if="game"
    :subtitle="$t('playerDetail.finishingMap')"></ChartExportLinksModal>
  </v-container>
</template>

<script>

import * as d3 from "d3";

import GameService from '../../services/game/game.service';
import XGChart from '../base/XGChart';
import RaceChart from '../base/RaceChart';
import Dictionary from "../../dictionary";
import { exportSvg,downloadPng,copyAndAppendElement } from '../../utils/exportToPNG'
import { getNeutralColors} from '../../utils/functions'
import GameAvatarMedia from './GameAvatarMedia';
import MediaModeForm from '../base/MediaModeForm';
import DriblabSocialMedia from '../base/DriblabSocialMedia';
import ChartExportLinksModal from '../base/ChartExportLinksModal';
import ShotsTable from '../base/ShotsTable';
import { v4 } from 'uuid';
import UserChartService from '../../services/user-chart.service';
import DocumentService from '../../services/document.service';
import {userHasRole,shotCoordToAreaName} from '../../utils/functions';
import UserService from '../../services/user.service';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8081';

const API_URL = NODE_ENV === 'production' ? 'https://pro.driblab.com/embed-chart/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/embed-chart/'


export default {
  name: 'GameFinishingMap',
  components: {
    XGChart,
    GameAvatarMedia,
    MediaModeForm,
    DriblabSocialMedia,
    ChartExportLinksModal,
    RaceChart,
    ShotsTable
  },
  props:{
    gameId:{
      type:Number,
      required: true
    },
    chartId:{
      type:Number,
      default: 0
    },
    defaultTab:{
      type: String,
      default: "topView"
    },
    language: {
      type: String,
      required: false
    },
  },
  watch: {
    "mediaMode": function(newVal, oldVal) {
      if(!this.mediaMode & this.game){
        this.mediaModeData = {leftBorderColor:"#3366FF",rightBorderColor:"#3366FF",bgColor:"#ffffff0",socialMedia:true,textColor:"#000000",logo:"color",
                      titleFontSize:"18",titleFontWeight:"900",subtitleFontSize:"14",subtitleFontWeight:"500",lineWeight:"2",lineLength:"180",avatarSize:"64"
                      ,subtitle2FontSize:"12",subtitle2FontWeight:"300",sponsor:{}}
        this.mediaModeData.subtitle = this.game.leagueName;
        this.mediaModeData.subtitle2 = this.$t('playerDetail.finishingMap');
        this.mediaModeData.titleLeft = this.game.homeTeamName;
        this.mediaModeData.titleRight = this.game.awayTeamName;
        this.mediaModeData.leftFillColor = this.game.homeTeamGameColor ? this.game.homeTeamGameColor.replace("0x","#") : getNeutralColors('home')[1];
        this.mediaModeData.rightFillColor = this.game.awayTeamGameColor ? this.game.awayTeamGameColor.replace("0x","#") : getNeutralColors('away')[1];
        this.mediaModeData.leftBorderColor = this.game.homeTeamGameSecondColor ? this.game.homeTeamGameSecondColor.replace("0x","#") : getNeutralColors('home')[0];
        this.mediaModeData.rightBorderColor = this.game.awayTeamGameSecondColor ? this.game.awayTeamGameSecondColor.replace("0x","#") : getNeutralColors('away')[0];
        this.mediaModeData.sponsor.src = require(`@/assets/img/driblab_normal_color.png`);
        this.mediaModeData.sponsor.fallBackSrc = require(`@/assets/img/driblab_normal_color.png`);
      }
      this.mediaModeData.bgColor = this.mediaMode ? '#ffffff' : '#ffffff0';
      this.onWindowResize(null,false)
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentUserLanguage() {
      return this.language ? this.language : this.$store.getters["auth/language"];
    },
    hasFirstOT(){
      return _.some(this.shots,(s) => s.periodId === 3)
    },
    hasSecondOT(){
      return _.some(this.shots,(s) => s.periodId === 4)
    },
    avatarSize(){
      return {
        width: this.size,
        height: this.size / 5.5
      }
    },
    lastSearchId() {
      return this.$store.state.auth.lastSearch;
    },
    darkMode(){
      return this.currentUser.darkMode || this.$vuetify.theme.dark;
    },
    hasPenalties() {
      return _.some(this.shots,(s) => s.strategyId === 9);
    },
    penalties() {
      return this.shots.filter((s) => s.strategyId === 9 && s.periodId !== 5);
    },
    penaltiesShootout() {
      return this.shots.filter((s) => s.strategyId === 9 && s.periodId === 5);
    }
  },
  data() {
    return {
      size: 0,
      margin: null,
      shots: [],
      filteredShots: [],
      game: null,
      playerNamesWithShots: [],
      xgMap: 0,
      showShotOptions: this.$vuetify.breakpoint.smAndDown ? false : true,
      shotTypes: [
        {id: 16, text: Dictionary[this.$i18n.locale]["finishingMap"]["goal"]},
        {id: 13, text: Dictionary[this.$i18n.locale]["finishingMap"]["missedShot"]},
        {id: 15, text: Dictionary[this.$i18n.locale]["finishingMap"]["savedShot"]},
        {id: 14, text: Dictionary[this.$i18n.locale]["finishingMap"]["shotOnPost"]},
        {id: 60, text: Dictionary[this.$i18n.locale]["finishingMap"]["missedChance"]}
      ],
      shotTypeModel: [13, 14, 15, 16, 60],
      shotStrategies: [
        {header: Dictionary[this.$i18n.locale]["finishingMap"]["openPlay"]},
        {id: 22, text: Dictionary[this.$i18n.locale]["finishingMap"]["regularPlay"]},
        {id: 23, text: Dictionary[this.$i18n.locale]["finishingMap"]["fastBreak"]},
        {id: 123, text: Dictionary[this.$i18n.locale]["game"]["gameThreat"]["keeperThrowPlay"]},
        {id: 215, text: Dictionary[this.$i18n.locale]["finishingMap"]["individualPlay"]},
        {divider: true},
        {header: Dictionary[this.$i18n.locale]["finishingMap"]["setPiece"]},
        {id: 26, text: Dictionary[this.$i18n.locale]["finishingMap"]["freeKick"]},
        {id: 24, text: Dictionary[this.$i18n.locale]["finishingMap"]["indirectFreeKick"]},
        {id: 25, text: Dictionary[this.$i18n.locale]["finishingMap"]["fromCorner"]},
        {id: 124, text: Dictionary[this.$i18n.locale]["game"]["gameThreat"]["gkKick"]},
        {id: 160, text: Dictionary[this.$i18n.locale]["finishingMap"]["throwInSetPiece"]},
        {id: 279, text: Dictionary[this.$i18n.locale]["videoHighlights"]["qualifierIds"]["279"]},
      ],
      shotStrategyModel: [22, 23, 123, 215, 24, 25, 26, 124, 160, 279],
      areas: [
        {header: Dictionary[this.$i18n.locale]["finishingMap"]["inBox"]},
        {id: 'goalArea', text: Dictionary[this.$i18n.locale]["finishingMap"]["goalArea"]},
        {id: 'boxLeft', text: Dictionary[this.$i18n.locale]["finishingMap"]["boxLeft"]},
        {id: 'boxCenter', text: Dictionary[this.$i18n.locale]["finishingMap"]["boxCenter"]},
        {id: 'boxRight', text: Dictionary[this.$i18n.locale]["finishingMap"]["boxRight"]},
        {divider: true},
        {header: Dictionary[this.$i18n.locale]["finishingMap"]["outOfBox"]},
        {id: 'outBoxDeepLeft', text: Dictionary[this.$i18n.locale]["finishingMap"]["outBoxDeepLeft"]},
        {id: 'outBoxDeepRight', text: Dictionary[this.$i18n.locale]["finishingMap"]["outBoxDeepRight"]},
        {id: 'outBoxLeft', text: Dictionary[this.$i18n.locale]["finishingMap"]["outBoxLeft"]},
        {id: 'outBoxCentreLeft', text: Dictionary[this.$i18n.locale]["finishingMap"]["outBoxCentreLeft"]},
        {id: 'outBoxCentre', text: Dictionary[this.$i18n.locale]["finishingMap"]["outBoxCentre"]},
        {id: 'outBoxCentreRight', text: Dictionary[this.$i18n.locale]["finishingMap"]["outBoxCentreRight"]},
        {id: 'outBoxRight', text: Dictionary[this.$i18n.locale]["finishingMap"]["outBoxRight"]},
        {id: 'left35', text: Dictionary[this.$i18n.locale]["finishingMap"]["left35"]},
        {id: 'centreLeft35', text: Dictionary[this.$i18n.locale]["finishingMap"]["centreLeft35"]},
        {id: 'centre35', text: Dictionary[this.$i18n.locale]["finishingMap"]["centre35"]},
        {id: 'centreRight35', text: Dictionary[this.$i18n.locale]["finishingMap"]["centreRight35"]},
        {id: 'right35', text: Dictionary[this.$i18n.locale]["finishingMap"]["right35"]}
      ],
      areaModel: ['goalArea', 'boxLeft', 'boxCenter', 'boxRight', 'outBoxDeepLeft', 'outBoxDeepRight', 'outBoxLeft',
        'outBoxCentreLeft', 'outBoxCentre', 'outBoxCentreRight', 'outBoxRight', 'left35', 'centreLeft35', 'centre35',
        'centreRight35', 'right35'],
      bodyParts: [
        {id: 15, text: Dictionary[this.$i18n.locale]["finishingMap"]["head"]},
        {id: 72, text: Dictionary[this.$i18n.locale]["finishingMap"]["leftFooted"]},
        {id: 20, text: Dictionary[this.$i18n.locale]["finishingMap"]["rightFooted"]},
        {id: 21, text: Dictionary[this.$i18n.locale]["finishingMap"]["otherBodyPart"]}
      ],
      bodyPartModel: [15, 20, 21, 72],
      minutes: [0, 90],
      checkboxCircles: ['circles'],
      periods: ['period1','period2', 'period3', 'period4', 'period5'],
      minutesMax: 90,
      minutesMin: 0,
      sizeMultiplier: 0.925,
      mediaMode: false,
      mediaModeData: {leftBorderColor:"#3366FF",rightBorderColor:"#3366FF",bgColor:"#ffffff0",socialMedia:true,textColor:"#000000",logo:"color",
                      titleFontSize:"18",titleFontWeight:"900",subtitleFontSize:"14",subtitleFontWeight:"500",lineWeight:"2",lineLength:"180",avatarSize:"64"
                      ,subtitle2FontSize:"12",subtitle2FontWeight:"300",sponsor:{}},
      mediaModeFields: [
        {type:"color",label:"mediaMode.fillColorX",key:"leftFillColor",labelParams:[1],home:true},
        {type:"color",label:"mediaMode.fillColorX",key:"rightFillColor",labelParams:[2],away:true},
        {type:"color",label:"mediaMode.borderColorX",key:"leftBorderColor",labelParams:[1],home:true},
        {type:"color",label:"mediaMode.borderColorX",key:"rightBorderColor",labelParams:[2],away:true},
        {type:"text",label:"mediaMode.titleX",key:"titleLeft",labelParams:[1],home:true},
        {type:"text",label:"mediaMode.titleX",key:"titleRight",labelParams:[2],away:true},
        {type:"number",label:"mediaMode.titleFontSize",key:"titleFontSize",force:true},
        {type:"radio",label:"mediaMode.titleFontWeight",key:"titleFontWeight"
          ,options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}],force:true},
        {type:"text",label:"mediaMode.subtitle",key:"subtitle"},
        {type:"number",label:"mediaMode.subtitleFontSize",key:"subtitleFontSize"},
        {type:"radio",label:"mediaMode.subtitleFontWeight",key:"subtitleFontWeight"
          ,options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}]},
        {type:"text",label:"mediaMode.subtitleX",key:"subtitle2",labelParams:[2]},
        {type:"number",label:"mediaMode.subtitleFontSizeX",key:"subtitle2FontSize",labelParams:[2]},
        {type:"radio",label:"mediaMode.subtitleFontWeightX",key:"subtitle2FontWeight",labelParams:[2]
          ,options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}]},
        {type:"color",label:"mediaMode.textColor",key:"textColor"},
        {type:"color",label:"mediaMode.bgColor",key:"bgColor"},
        {type:"number",label:"mediaMode.avatarLineLength",key:"lineLength",force:true},
        {type:"number",label:"mediaMode.avatarLineWeight",key:"lineWeight",force:true},
        {type:"number",label:"mediaMode.avatarSize",key:"avatarSize",force:true},
        {type:"switch",label:"mediaMode.socialMedia",key:"socialMedia"},
        {type:"number",label:"mediaMode.socialMediaFontSize",key:"socialMediaFontSize",force:true},
        {type:"radio",label:"mediaMode.socialMediaFontWeight",key:"socialMediaFontWeight"
          ,options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}],force:true},
        {type:"image",label:"mediaMode.sponsor",key:"sponsor",force:true,aspectRatio:16/9,imageRestriction:'none',resizable:true,stencilSize:{width:300,height:300}}
      ],
      chartSize: null,
      loadingExport: false,
      selectedTab: this.defaultTab,
      showPenalties: false,
      showShootoutPenalties: false
    };
  },
  mounted: function() {
    this.mediaMode = (this.currentUser.mediaMode || this.currentUser.clientType === 'Media');
    this.size = this.$refs.chart.clientWidth * this.sizeMultiplier;
  },
  created() {
    window.addEventListener("resize", this.onWindowResize);
    Promise.all([GameService.getXGShots(this.gameId), GameService.getGame(this.gameId)]).then(([shotsData, gameData]) => {
      this.shots = shotsData.data.map(s => {
        if (s.strategyId === 9) {
          //Adjust penalty shots' values
          s.xG = [15, 16].includes(s.eventTypeId) ? 0.765 : 0;
          s.xgOnTarget = [15, 16].includes(s.eventTypeId) ? 0.765 : 0;
          s.y = 50;
          s.x = 88.5;
        };
        return s;
      });
      this.setShotsArea()
      this.game = gameData.data;
      this.game.homeColorHex = this.game.homeTeamColor && this.game.homeTeamColor != '0xFFFFFF' ? this.game.homeTeamColor.replace("0x",'#') : '#86bc25';
      this.game.awayColorHex = this.game.awayTeamColor && this.game.awayTeamColor != '0xFFFFFF' ? this.game.awayTeamColor.replace("0x",'#') : '#25cb86';

      this.mediaModeData.subtitle = this.game.leagueName;
      this.mediaModeData.subtitle2 = this.$t('playerDetail.finishingMap');
      this.mediaModeData.titleLeft = this.game.homeTeamName;
      this.mediaModeData.titleRight = this.game.awayTeamName;
      this.mediaModeData.leftFillColor = this.game.homeTeamGameColor ? this.game.homeTeamGameColor.replace("0x","#") : getNeutralColors('home')[1];
      this.mediaModeData.rightFillColor = this.game.awayTeamGameColor ? this.game.awayTeamGameColor.replace("0x","#") : getNeutralColors('away')[1];
      this.mediaModeData.leftBorderColor = this.game.homeTeamGameSecondColor ? this.game.homeTeamGameSecondColor.replace("0x","#") : getNeutralColors('home')[0];
      this.mediaModeData.rightBorderColor = this.game.awayTeamGameSecondColor ? this.game.awayTeamGameSecondColor.replace("0x","#") : getNeutralColors('away')[0];
      this.mediaModeData.sponsor.src = require(`@/assets/img/driblab_normal_color.png`);
      this.mediaModeData.sponsor.fallBackSrc = require(`@/assets/img/driblab_normal_color.png`);
      this.mediaModeFields = _.map(this.mediaModeFields,(f) => {
        if(f.home){
          f.labelParams = [this.game.homeTeamName];
        }
        if(f.away){
          f.labelParams = [this.game.awayTeamName];
        }
        return f;
      })
      this.$forceUpdate();

      this.updateMins();
      this.minutes = [this.minutesMin, this.minutesMax];
      this.updateShots();
      UserService.putLastSearchRendered({id:this.lastSearchId});
    });
  },
  methods: {
    onWindowResize(e,force=false) {
      if (this.size != this.$refs.chart.clientWidth * this.sizeMultiplier) {
        this.size = this.$refs.chart.clientWidth * this.sizeMultiplier;
      }
      this.xgMap += 1;
      if(this.$refs.gameAvatarMediaRef){
        this.$refs.gameAvatarMediaRef.printD3(force)
      }
      if(this.$refs.driblabSocialMediaRef){
        this.$refs.driblabSocialMediaRef.printD3(force)
      }
      this.$forceUpdate();
    },
    shotsInArea(shots) {
      return shots
        .filter(s => this.areaModel.includes('goalArea') || !(s.x >= 94.2 && s.y >= 36.8 && s.y <= 63.2))
        .filter(s => this.areaModel.includes('boxRight') || !(s.x >= 83 && s.y >= 21.1 && s.y < 36.8))
        .filter(s => this.areaModel.includes('boxCenter') || !(s.x >= 83 && s.x < 94.2 && s.y >= 36.8 && s.y <= 63.2))
        .filter(s => this.areaModel.includes('boxLeft') || !(s.x >= 83 && s.y > 63.2 && s.y <= 78.9))
        .filter(s => this.areaModel.includes('outBoxDeepRight') || !(s.x >= 83 && s.y < 21.1))
        .filter(s => this.areaModel.includes('outBoxDeepLeft') || !(s.x >= 83 && s.y > 78.9))
        .filter(s => this.areaModel.includes('outBoxRight') || !(s.x >= 65 && s.x < 83 && s.y < 21.1))
        .filter(s => this.areaModel.includes('outBoxCentreRight') || !(s.x >= 65 && s.x < 83 && s.y >= 21.1 && s.y <= 35.5))
        .filter(s => this.areaModel.includes('outBoxCentre') || !(s.x >= 65 && s.x < 83 && s.y > 35.5 && s.y <= 64.4))
        .filter(s => this.areaModel.includes('outBoxCentreLeft') || !(s.x >= 65 && s.x < 83 && s.y > 64.4 && s.y <= 78.9))
        .filter(s => this.areaModel.includes('outBoxLeft') || !(s.x >= 65 && s.x < 83 && s.y > 78.9))
        .filter(s => this.areaModel.includes('right35') || !(s.x >= 50 && s.x < 65 && s.y < 21.1))
        .filter(s => this.areaModel.includes('centreRight35') || !(s.x >= 50 && s.x < 65 && s.y >= 21.1 && s.y <= 35.5))
        .filter(s => this.areaModel.includes('centre35') || !(s.x >= 50 && s.x < 65 && s.y > 35.5 && s.y <= 64.4))
        .filter(s => this.areaModel.includes('centreLeft35') || !(s.x >= 50 && s.x < 65 && s.y > 64.4 && s.y <= 78.9))
        .filter(s => this.areaModel.includes('left35') || !(s.x >= 50 && s.x < 65 && s.y > 78.9))
    },
    updateShots() {
      this.updateMins();
      const minutesMaxFilter = this.minutes[1];
      this.filteredShots = this.shots
      .filter(s => this.shotTypeModel.includes(s.eventTypeId))
      .filter(s => this.shotStrategyModel.includes(s.strategyId) || !s.strategy)
      .filter(s => this.bodyPartModel.includes(s.bodyPartId))
      .filter(s => _.some(this.periods,p => p.includes(s.periodId)))
      .filter(s => s.min >= this.minutes[0] && s.min <= minutesMaxFilter);

      //Add penalties if they are selected
      if (this.showPenalties) this.filteredShots = this.filteredShots.concat(this.penalties);
      if (this.showShootoutPenalties) this.filteredShots = this.filteredShots.concat(this.penaltiesShootout);

      this.filteredShots = this.shotsInArea(this.filteredShots)
      let filteredShotsByxG = _.orderBy(this.filteredShots,['xG'],['desc']);
      this.filteredShots = _.orderBy(this.filteredShots,['periodId','min','sec'],['asc','asc','asc']);
      this.$emit("filteredShots", filteredShotsByxG);
      this.xgMap += 1;
    },
    toggleShotStrategies () {
      this.$nextTick(() => {
        if (this.allShotStrategies) {
          this.shotStrategyModel = []
        } else {
          //Need filter beacause shotStrategies array has 10 items, 7 strategies and 3 other items (2 headers and 1 divider)
          this.shotStrategyModel = this.shotStrategies.filter(function(sS){ return sS.id ? true : false }).map(function(sS) { return sS.id; })
        }
      })
    },
    toggleShotTypes () {
      this.$nextTick(() => {
        if (this.allShotTypes) {
          this.shotTypeModel = []
        } else {
          this.shotTypeModel = this.shotTypes.map(function(p) { return p.id; })
        }
        this.updateShots();
      })
    },
    toggleAreas () {
      this.$nextTick(() => {
        if (this.allAreas) {
          this.areaModel = []
        } else {
          this.areaModel = this.areas.filter(function(sS){ return sS.id ? true : false }).map(function(p) { return p.id; })
        }
        this.updateShots();
      })
    },
    toggleBodyPart () {
      this.$nextTick(() => {
        if (this.allBodyParts) {
          this.bodyPartModel = []
        } else {
          this.bodyPartModel = this.bodyParts.map(function(p) { return p.id; })
        }
        this.updateShots();
      })
    },
    updateMins(){
      this.minutesMin = 0;
      this.minutesMax = _.chain(this.shots).map(s => s.min).max().value();
      if(this.minutesMax < 90){
        this.minutesMax = 90;
      };
    },
    saveAsPNG() {
      if(this.mediaMode && this.selectedTab === 'topView'){
         downloadPng(this.prepareSvgForMedia(),`Driblab XGMap - ${this.game.homeTeamName} ${this.game.homeTeamScore}:${this.game.awayTeamScore} ${this.game.awayTeamName}.png`);
      }else{
        let id = this.selectedTab === 'topView' ? `#pitchXG${this.gameId}-${this.chartId}` : `#raceChartgameXG`
        let svg = d3.select(id)
        .select("svg").node()
        downloadPng(svg,`Driblab XGMap - ${this.game.homeTeamName} ${this.game.homeTeamScore}:${this.game.awayTeamScore} ${this.game.awayTeamName}.png`);
      }
    },
    saveAsSVG() {
      if(this.mediaMode && this.selectedTab === 'topView'){
        exportSvg(this.prepareSvgForMedia(), `Driblab XGMap - ${this.game.homeTeamName} ${this.game.homeTeamScore}:${this.game.awayTeamScore} ${this.game.awayTeamName}`);
      }else{
        let id = this.selectedTab === 'topView' ? `#pitchXG${this.gameId}-${this.chartId}` : `#raceChartgameXG`
        let svg = d3.select(id)
        .select("svg").node()
         exportSvg(svg, `Driblab XGMap - ${this.game.homeTeamName} ${this.game.homeTeamScore}:${this.game.awayTeamScore} ${this.game.awayTeamName}`);
      }
    },
    getElementToExport(){
      if(this.mediaMode && this.selectedTab === 'topView'){
        return this.prepareSvgForMedia();
      }else{
        let id = this.selectedTab === 'topView' ? `#pitchXG${this.gameId}-${this.chartId}` : `#raceChartgameXG`
        let svg = d3.select(id)
        .select("svg").node()
       return svg;
      }
    },
    onMediaModeChange(event){
      this.mediaMode = event;
    },
    onMediaModeDataChange(event){
      this.mediaModeData = {...event};
      setTimeout(() => {this.onWindowResize(null,this.mediaModeData.force);},666)
    },
    prepareSvgForMedia(){
      let parent = document.createElementNS('http://www.w3.org/2000/svg','svg');
      let heightAccum = 0;
      parent.style.background = this.mediaModeData.bgColor;
      //COPY HEADER
      copyAndAppendElement(parent,document.querySelector(`#gameAvatarMedia${this.gameId}-${this.chartId}SVG`), 50, 0)
      heightAccum += this.avatarSize.height;
      //COPY PICTH
      copyAndAppendElement(parent,document.querySelector(`#pitchXG${this.gameId}-${this.chartId}SVG`), 50, this.avatarSize.height)
      heightAccum += this.chartSize.height;
      if(this.mediaModeData.socialMedia){
        //COPY SOCIAL MEDIA
        copyAndAppendElement(parent,document.querySelector(`#driblabSocialMedia${this.gameId}-${this.chartId}SVG`), 50, this.avatarSize.height + this.chartSize.height)
        heightAccum += 50;
      }

      parent.setAttribute("width", this.chartSize.width + 75);
      parent.setAttribute("height", heightAccum);
      return parent;
    },
    onChartSizeChange(event){
      this.chartSize = event;
    },
    onLoaded(event){
      //Emit when is loaded
      this.$emit("loaded", event);
    },
    isWhite(color){
      return color === "#FFF" || color === "#fff" || color === "#FFFFFF" || color === "#ffffff" || color === "white";
    },
    async onGenerateIFrameClick(){
      this.loadingExport = true;
      let elToExport = this.getElementToExport();
      let key = v4();
      key = `${key}.json`;
      let chartObject = {
        awsKey:key,
        tool: 'finishing-map',
        category: 'game',
        componentId: this.gameId,
        width: elToExport.getAttribute("width"),
        height: this.mediaMode && this.selectedTab === 'topView' ? elToExport.getAttribute("width") * 0.9925 : elToExport.getAttribute("width") * 0.806
      }
      let postResponse = await UserChartService.postChart(chartObject)
      let chartEntity = postResponse.data;

      this.$refs.chartExportLinksModalRef.open(chartEntity);
      this.loadingExport = false;

      let urlResponse = await UserChartService.getUploadURL(chartEntity.id,key);
      let uploadUrl = urlResponse.data;
      var jsonse = JSON.stringify({
        size: Number(chartEntity.width),
        height: Number(chartEntity.height),
        shots: this.filteredShots,
        circlesAndBoxes: this.checkboxCircles,
        language:this.currentUserLanguage,
        mediaModeData: this.mediaModeData,
        mediaMode: this.mediaMode,
        playerAvatarKey: 0,
        key: this.xgMap,
        socialMediaKey: 2,
        id: `${this.gameId}-${this.chartId}`,
        game:this.game,
        chartType:"finishing-map",
        category: 'game',
        selectedTab:this.selectedTab
      });

      var blob = new Blob([jsonse], {type: "application/json"});
      // let blob = exportSvgToFile(elToExport);
      let uploadResponse = await DocumentService.upload(uploadUrl,blob);

      this.postSearchChart(chartEntity);
    },
    async postSearchChart(chart){
      const authorized = true;
      let metaInfo = null;
      let category = 'game';
      let urlId = this.gameId;

      metaInfo = JSON.stringify({
        link: `${API_URL}${chart.id}/key/${chart.awsKey}/compId/${chart.componentId}/catId/${chart.categoryId}/tId/${chart.toolId}`
      });
      const tool = 'embed';
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const browser = navigator.userAgent;
      let searchResponse = await UserService.postUserSearch(category, tool, urlId, authorized, this.$route.path, timeZone, browser, metaInfo);
      UserService.putLastSearchRendered({category,tool,id:searchResponse.data})
    },
    userHasRole(role) {
      return userHasRole(this.currentUser, role);
    },
    onTabChange(){
      this.toggleShotTypes();
      this.toggleShotStrategies();
      this.toggleAreas();
      this.toggleBodyPart();
      this.periods = ['period1','period2','period3','period4', 'period5'];
      this.updateMins();
      this.mediaMode = false;
      this.onMediaModeChange();
      setTimeout(() => this.onWindowResize(),100);
    },
    setShotsArea(){
      this.shots = _.map(this.shots,(s) => {
        s.areaName = shotCoordToAreaName(s);
        s.areaLabel = s.areaName ? this.$t(`finishingMap.${s.areaName}`) : '';
        s.typeLabel = this.$t(`finishingMap.${_.camelCase(s.type)}`);
        return s;
      })
    }
  },
  destroyed() {
    d3.selectAll('.tooltip').remove();
    window.removeEventListener("resize", this.onWindowResize);
  },
};
</script>

<style>
  body > div.tooltip {
    font-family: 'NeueMontreal';
    pointer-events: none;
    position: absolute;
    background: none repeat scroll 0 0 #ffffff;
    padding: 5px 10px 5px 10px;
    border-radius: 4px;
    text-align: center;
    display: none;
    line-height: 1.5;
    color: #081F2C;
    box-shadow: 0px 3px 9px rgba(0, 0, 0, .15);
  }

  body > div.tooltip:after {
    box-sizing: border-box;
    display: block;
    width: 100%;
    line-height: 2.8;
    color: #ffffff;
    content: "\25BC";
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/game/GameFinishingMap.vue